import { styled } from '@zenbusiness/zui/styles';
import { Link as RouterLink } from 'react-router-dom';

export const Link = styled(RouterLink)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
  textDecoration: 'none'
}));
